/* Outlet page — carrousel-pijlen, filters/sorteren, en de Superdeal keuze-banner.
   De producttegels en hun toevoegen-knop zijn de bestaande site-tegels (product-row-card
   + globale .js-quick-add handler). Hier dus geen eigen add-logica. */
(function () {
  'use strict';
  var root = document.querySelector('.co-outlet');
  if (!root) return;

  /* ── Carrousel pijlen (drag-scroll komt al van de globale initAllDragScroll) ── */
  var track = root.querySelector('[data-co-track]');

  /* "Max 1 per klant"-label op elke Superdeal-kaart (i.p.v. het hartje) */
  if (track) {
    track.querySelectorAll('.product-row__card').forEach(function (card) {
      if (card.querySelector('.co-maxlabel')) return;
      var lab = document.createElement('span');
      lab.className = 'co-maxlabel';
      lab.textContent = 'Max 1 per klant';
      card.appendChild(lab);
    });
  }
  function step(dir) {
    if (!track) return;
    var card = track.querySelector('.product-row__card');
    var w = card ? card.getBoundingClientRect().width + 14 : 214;
    track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
  }
  root.querySelectorAll('[data-co-arrow]').forEach(function (b) {
    b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-co-arrow'), 10)); });
  });
  if (root.getAttribute('data-co-autoscroll') === '1' && track) {
    var paused = false;
    ['pointerenter', 'pointerdown', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }); });
    track.addEventListener('pointerleave', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else step(1);
    }, 3400);
  }

  /* ── Superdeal keuze-banner (max 1) ── */
  var banner = root.querySelector('[data-co-banner]');
  var sdSet = {}, sdNames = {};
  if (track) {
    track.querySelectorAll('[data-variant-id]').forEach(function (el) {
      var id = String(el.getAttribute('data-variant-id'));
      if (!id) return;
      sdSet[id] = true;
      var t = el.getAttribute('data-product-title');
      if (t && !sdNames[id]) sdNames[id] = t;
    });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; }); }
  function syncBanner(cart) {
    var chosenId = null, chosenName = '';
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var vid = String(cart.items[i].variant_id);
        if (sdSet[vid]) { chosenId = vid; chosenName = sdNames[vid] || cart.items[i].product_title.replace('[DEAL] ', ''); break; }
      }
    }
    if (banner) {
      banner.classList.toggle('is-chosen', !!chosenId);
      var nm = banner.querySelector('[data-co-chosen-name]');
      if (nm) nm.textContent = chosenName;
      banner.setAttribute('data-chosen-id', chosenId || '');
    }
    /* Superdeals = max 1 per bestelling: knop-tekst per kaart.
       Gekozen Superdeal -> "Toegevoegd" (stepper is verborgen via CSS);
       andere Superdeals -> "Vervangen" zodra er een Superdeal in 't mandje zit;
       niets gekozen -> "Toevoegen". (replace zelf regelt cart-deal-guard.js) */
    if (track) {
      track.querySelectorAll('.product-row__card-cta').forEach(function (cta) {
        var cvid = String(cta.getAttribute('data-variant-id') || '');
        var txt = cta.querySelector('.product-row__card-atc-text');
        if (!txt) return;
        if (chosenId && cvid === chosenId) {
          txt.textContent = 'Toegevoegd';
          cta.classList.add('co-sd-added'); cta.classList.remove('co-sd-replace');
        } else if (chosenId) {
          txt.textContent = 'Vervangen';
          cta.classList.add('co-sd-replace'); cta.classList.remove('co-sd-added');
        } else {
          txt.textContent = 'Toevoegen';
          cta.classList.remove('co-sd-added'); cta.classList.remove('co-sd-replace');
        }
      });
    }
  }
  function refreshBanner() { return getCart().then(syncBanner); }
  var rmBtn = root.querySelector('[data-co-banner-remove]');
  if (rmBtn) rmBtn.addEventListener('click', function () {
    var id = banner.getAttribute('data-chosen-id');
    if (!id) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: String(id), quantity: 0 }) })
      .then(function () { try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} })); } catch (e) {} return refreshBanner(); });
  });
  document.addEventListener('cart:updated', refreshBanner);
  document.addEventListener('cart:deal-corrected', refreshBanner);
  refreshBanner();

  /* ── Filters + sorteren + "toon meer" (Afgeprijsd) ── */
  var grid = root.querySelector('[data-co-grid]');
  var countEl = root.querySelector('[data-co-count]'), noRes = root.querySelector('[data-co-noresults]');
  var brandSel = root.querySelector('[data-co-filter="brand"]');
  var typeSel = root.querySelector('[data-co-filter="type"]');
  var sortSel = root.querySelector('[data-co-sort]');
  var lmWrap = root.querySelector('[data-co-loadmore-wrap]');
  var lmBtn = root.querySelector('[data-co-loadmore]');
  var fstate = { brand: '', type: '', price: '' };
  var tiles = [];

  function refreshTiles() { tiles = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-co-tile]')) : []; }

  function applyFilters() {
    var shown = 0;
    tiles.forEach(function (tile) {
      var ok = true;
      if (fstate.brand && tile.getAttribute('data-brand') !== fstate.brand) ok = false;
      if (fstate.type && tile.getAttribute('data-type') !== fstate.type) ok = false;
      if (ok && fstate.price) { var pr = parseInt(tile.getAttribute('data-price'), 10) || 0; var pa = fstate.price.split('-'); if (pr < parseInt(pa[0], 10) || pr >= parseInt(pa[1], 10)) ok = false; }
      tile.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    if (countEl) countEl.textContent = shown + ' product' + (shown === 1 ? '' : 'en');
    if (noRes) noRes.hidden = shown !== 0;
  }

  /* Merk/Type-dropdowns opbouwen uit ALLE geladen tegels (niet alleen de eerste 50). */
  function rebuildOptions(sel, values) {
    if (!sel) return;
    var cur = sel.value;
    var first = sel.querySelector('option');
    sel.innerHTML = '';
    if (first) sel.appendChild(first);
    values.sort(function (a, b) { return a.localeCompare(b); }).forEach(function (v) {
      var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o);
    });
    sel.value = cur;
  }
  function rebuildFilterOptions() {
    var bset = {}, tset = {};
    tiles.forEach(function (t) {
      var b = t.getAttribute('data-brand'); if (b) bset[b] = 1;
      var ty = t.getAttribute('data-type'); if (ty) tset[ty] = 1;
    });
    rebuildOptions(brandSel, Object.keys(bset));
    rebuildOptions(typeSel, Object.keys(tset));
  }

  function applySort() {
    if (!sortSel || !grid) return;
    var m = sortSel.value, arr = tiles.slice();
    arr.sort(function (a, b) {
      var pa = parseInt(a.getAttribute('data-price'), 10) || 0, pb = parseInt(b.getAttribute('data-price'), 10) || 0;
      var na = a.getAttribute('data-name') || '', nb = b.getAttribute('data-name') || '';
      var da = (parseInt(a.getAttribute('data-from'), 10) || 0) - pa, db = (parseInt(b.getAttribute('data-from'), 10) || 0) - pb;
      if (m === 'price-asc') return pa - pb;
      if (m === 'price-desc') return pb - pa;
      if (m === 'title-asc') return na.localeCompare(nb);
      if (m === 'discount') return db - da;
      return 0; /* featured = server/collectie-volgorde */
    });
    arr.forEach(function (t) { grid.appendChild(t); });
    if (noRes) grid.appendChild(noRes);
  }

  function afterLoad() {
    refreshTiles();
    rebuildFilterOptions();
    if (sortSel && sortSel.value && sortSel.value !== 'featured') applySort();
    applyFilters();
  }

  /* ── Load-more via Section Rendering API ── */
  var totalPages = grid ? (parseInt(grid.getAttribute('data-co-pages'), 10) || 1) : 1;
  var sectionId = grid ? grid.getAttribute('data-co-section') : '';
  var basePath = grid ? (grid.getAttribute('data-co-base') || location.pathname) : location.pathname;
  var loadedPages = 1, loadingAll = false;
  var seen = {};
  if (grid) grid.querySelectorAll('[data-co-tile]').forEach(function (t) { var h = t.getAttribute('data-handle'); if (h) seen[h] = 1; });

  function fetchPage(n) {
    var url = basePath + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + n;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var srcGrid = doc.querySelector('[data-co-grid]');
      if (!srcGrid) return;
      srcGrid.querySelectorAll('[data-co-tile]').forEach(function (t) {
        var h = t.getAttribute('data-handle');
        if (h && seen[h]) return;
        if (h) seen[h] = 1;
        if (noRes && noRes.parentNode === grid) grid.insertBefore(t, noRes); else grid.appendChild(t);
      });
    }).catch(function () {});
  }

  function loadNext() {
    if (loadedPages >= totalPages) { if (lmWrap) lmWrap.hidden = true; return Promise.resolve(); }
    var n = loadedPages + 1;
    if (lmBtn) lmBtn.setAttribute('aria-busy', 'true');
    return fetchPage(n).then(function () {
      loadedPages = n;
      afterLoad();
      if (lmBtn) lmBtn.removeAttribute('aria-busy');
      if (loadedPages >= totalPages && lmWrap) lmWrap.hidden = true;
    });
  }
  function loadAll() {
    if (loadingAll || loadedPages >= totalPages) return Promise.resolve();
    loadingAll = true;
    function stepAll() {
      if (loadedPages >= totalPages) { if (lmWrap) lmWrap.hidden = true; return Promise.resolve(); }
      return loadNext().then(stepAll);
    }
    return stepAll().then(function () { loadingAll = false; });
  }

  /* init */
  refreshTiles();
  rebuildFilterOptions();

  root.querySelectorAll('[data-co-filter]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      fstate[sel.getAttribute('data-co-filter')] = sel.value;
      applyFilters();
      loadAll(); /* filter over ALLE producten, niet alleen de eerste pagina */
    });
  });
  var reset = root.querySelector('[data-co-filter-reset]');
  if (reset) reset.addEventListener('click', function () { fstate = { brand: '', type: '', price: '' }; root.querySelectorAll('[data-co-filter]').forEach(function (s) { s.value = ''; }); applyFilters(); });
  var ftoggle = root.querySelector('[data-co-filter-toggle]'), fpanel = root.querySelector('[data-co-filters]');
  if (ftoggle && fpanel) ftoggle.addEventListener('click', function () { fpanel.classList.toggle('is-open'); });
  if (sortSel && grid) sortSel.addEventListener('change', function () { applySort(); applyFilters(); loadAll(); });
  if (lmBtn) lmBtn.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });

  applyFilters();
})();
